var THREE = window.THREE = require('three/build/three.min.js');
require('three/examples/js/loaders/GLTFLoader.js');
import TWEEN from '@tweenjs/tween.js';

var camera, scene, renderer, clock, textGeo, textTexture, textMaterial, text, light, lightcube, smokeTexture, smokeMaterial, smokeGeo,
  smokeParticles, delta, cube, tween, tweenLightcube, tweenSafetext, tweenSpotlightLeft, videoTexture,
  lightcube2, tweenLightcube2, ambientTween;

const mouse = new THREE.Vector2();
var windowHalf = new THREE.Vector2( document.getElementById('welcome').offsetWidth / 2, document.getElementById('welcome').offsetHeight / 2 );

init();
animate();

function init() {

  document.addEventListener( 'mousemove', onMouseMove, false );

  clock = new THREE.Clock();

  const loadingManager = new THREE.LoadingManager();

  loadingManager.onLoad = function ( ) {
    const loadingScreen = document.getElementById( 'loading-screen' );
    loadingScreen.remove();
  };

  loadingManager.onProgress = function ( url, itemsLoaded, itemsTotal ) {
    console.log( 'Loaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
  };


  renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true } );
  renderer.setSize( document.getElementById('welcome').offsetWidth, document.getElementById('welcome').offsetHeight, );
  scene = new THREE.Scene();
  camera = new THREE.PerspectiveCamera( 45, document.getElementById('welcome').offsetWidth/ document.getElementById('welcome').offsetHeight, 0.1, 10000 );
  camera.position.z = 1700;
  camera.position.y = -80;
  scene.add( camera );

  var ambientLight = new THREE.AmbientLight( 0xffffff, 0 )

  scene.add( ambientLight );
  ambientTween = new TWEEN.Tween( ambientLight ).to( { intensity: 0.3 }, 8000 );
  ambientTween.delay(4000);
  ambientTween.start();
  /*var helper = new THREE.CameraHelper( camera );
  scene.add( helper );*/

  //scene.add(new THREE.GridHelper(15, 20));

  // instantiate a loader
  var loader = new THREE.GLTFLoader(loadingManager);
  loader.load( 'images/layout/cube_inotec.gltf', function ( gltf ) {
    let cubeO = gltf.scene;

    const cubeTexture = new THREE.TextureLoader(loadingManager).load('images/layout/metal_texture.jpg');
    cubeTexture.wrapS = THREE.MirroredRepeatWrapping;
    cubeTexture.wrapT = THREE.MirroredRepeatWrapping;
    cubeTexture.mapping = THREE.EquirectangularReflectionMapping;
    const cubeMaterial = new THREE.MeshPhongMaterial({color: 0x555555, reflectivity: 20, shininess: 50, opacity: 1, map: cubeTexture})
    gltf.scene.traverse( function ( child ) {
      if ( child instanceof THREE.Mesh ) {
        child.material = cubeMaterial;
      }
    } );
    cubeO.position.x = -23;
    cubeO.position.y = -300;
    cubeO.position.z = -1850;
    cubeO.rotation.y = -0.75;
    cubeO.rotation.x = -0.35;
    cubeO.scale.x = 4;
    cubeO.scale.y = 4;
    cubeO.scale.z = 4;

    cube = cubeO
    scene.add( cube );

    tween = new TWEEN.Tween(cube.position);
    tween.easing(TWEEN.Easing.Quintic.InOut);
    tween.to({z: -350}, 2800);
    tween.start();

  }, undefined, function ( error ) {
    console.error( error );
  } );

  /*textGeo = new THREE.PlaneGeometry(300,112);
  textGeo.scale(0.8,0.8,1)
  textTexture = new THREE.TextureLoader(loadingManager).load('images/layout/logo.png');
  textMaterial = new THREE.MeshLambertMaterial({color: 0xffffff, opacity: 1.5, map: textTexture, transparent: true, blending: THREE.AdditiveBlending})
  text = new THREE.Mesh(textGeo,textMaterial);
  text.position.x = 0;
  text.position.y = 250;
  text.position.z = 650;
  scene.add(text);*/

  videoTexture = new THREE.TextureLoader(loadingManager).load('images/layout/smoke_bg_short_mini.mp4');

  var safetextGeo = new THREE.PlaneGeometry(1016,108);
  safetextGeo.scale(0.8,0.8,1)
  var safetextTexture = new THREE.TextureLoader(loadingManager).load('images/layout/sindsiesicher.png');
  var safetextMaterial = new THREE.MeshLambertMaterial({color: 0xffffff, opacity: 1, map: safetextTexture, transparent: true})
  var safetext = new THREE.Mesh(safetextGeo,safetextMaterial)
  safetext.position.x = 0;
  safetext.position.y = 470;
  safetext.position.z = 650;
  scene.add(safetext);

  tweenSafetext = new TWEEN.Tween(safetext.position);
  tweenSafetext.delay(3000)
  tweenSafetext.easing(TWEEN.Easing.Cubic.Out);
  tweenSafetext.to({y: 260}, 2800);
  tweenSafetext.start();

  smokeTexture = new THREE.TextureLoader(loadingManager).load('images/layout/smoke.png');
  smokeMaterial = new THREE.MeshBasicMaterial({color: 0xC6DAE4, map: smokeTexture, transparent: true, opacity : 0});
  smokeGeo = new THREE.PlaneGeometry(250,250);
  smokeGeo.scale(1.2,1.2,1)
  smokeGeo.translate(0,0,250)
  smokeParticles = [];
  light = new THREE.DirectionalLight(0xffffff,1);
  light.position.set(-1,0,-5);
  scene.add(light);


  lightcube = new THREE.PointLight(0x009ee3, 0);
  lightcube.castShadow = false;
  lightcube.position.set(0,-150,-250);
  scene.add(lightcube);
  new TWEEN.Tween( lightcube ).to( { intensity: 2.5 }, 5000 ).delay(2000).start();

  tweenLightcube = new TWEEN.Tween(lightcube.position);
  tweenLightcube.delay(4000);
  tweenLightcube.easing(TWEEN.Easing.Quadratic.InOut);
  tweenLightcube.to({x: -150, y: -250, z: -250}, 10000);
  tweenLightcube.yoyo(true);
  tweenLightcube.repeat(Infinity);
  tweenLightcube.start();

  lightcube2 = new THREE.PointLight(0x009ee3, 0);
  lightcube2.castShadow = false;
  lightcube2.position.set(-270,-450,30);
  scene.add(lightcube2);
  new TWEEN.Tween( lightcube2 ).to( { intensity: 2.5 }, 5000 ).delay(2000).start();
  tweenLightcube2 = new TWEEN.Tween(lightcube2.position);
  tweenLightcube2.delay(4000);
  tweenLightcube2.easing(TWEEN.Easing.Quadratic.InOut);
  tweenLightcube2.to({x: -70, y: -450, z: -300}, 10000);
  tweenLightcube2.yoyo(true);
  tweenLightcube2.repeat(Infinity);
  tweenLightcube2.start();

  var spotLightLeft = new THREE.PointLight( 0xdb752c, 0 );
  spotLightLeft.position.set( -1100, -100, 300 );
  new TWEEN.Tween( spotLightLeft ).to( { intensity: 3 }, 5000 ).delay(2000).start();
  scene.add( spotLightLeft );

  tweenSpotlightLeft = new TWEEN.Tween(spotLightLeft.position);
  tweenSpotlightLeft.easing(TWEEN.Easing.Quadratic.InOut);
  tweenSpotlightLeft.delay(4000);
  tweenSpotlightLeft.to({x: 1110, y: -100, z: 300}, 10000);
  tweenSpotlightLeft.yoyo(true)
  tweenSpotlightLeft.repeat(Infinity)
  tweenSpotlightLeft.start()

  /*var sphereSize = 100;
  var pointLightHelper = new THREE.PointLightHelper( spotLightLeft, sphereSize );
  scene.add( pointLightHelper );*/


  var spotLightRight = new THREE.PointLight( 0xffffff, 0 );
  spotLightRight.position.set( 1100, 100, 10 );
  scene.add( spotLightRight );
  new TWEEN.Tween( spotLightRight ).to( { intensity: 1 }, 5000 ).delay(1000).start();
  /*var spotLightHelperRight = new THREE.SpotLightHelper( spotLightRight, 0xffffff );
  scene.add( spotLightHelperRight );*/

  for (let p = 0; p < 80; p++) {
    var particle = new THREE.Mesh(smokeGeo,smokeMaterial);
    new TWEEN.Tween( smokeMaterial ).to( { opacity: 0.3 }, 8000 ).start();
    particle.position.set(Math.random()*900-500,Math.random()*600-400,Math.random()*500-220);
    particle.rotation.z = Math.random() * 360;
    scene.add(particle);
    smokeParticles.push(particle);
  }

  $('#welcome .content').append(renderer.domElement)
  $('#welcome .content').append('<video id="smokeBack" src="images/layout/smoke_bg_short_mini.mp4" autoplay loop></video>')
  window.addEventListener( 'resize', onWindowResize, false );
}

function onMouseMove( event ) {
  mouse.x = ( event.clientX - windowHalf.x );
  mouse.y = ( event.clientY - windowHalf.y );
}

function animate() {
  delta = clock.getDelta();
  requestAnimationFrame( animate );
  if (light.position.z < 1) {
    light.position.z += 0.03;
  }
  TWEEN.update();
  // Follow mouse to some extent
  let maxWidth = document.getElementById('welcome').offsetWidth;
  let spdx =  ((maxWidth / 2 - mouse.x) / (1 / Math.abs(mouse.x)) / 100000000);
  if (mouse.x > 0) {
      spdx = ((maxWidth / 2 + mouse.x) / (1 / Math.abs(mouse.x)) / 100000000);
  }

  if (cube !== undefined && cube.hasOwnProperty('rotation')) {
    if (mouse.x > 30 || mouse.x < -30 && (cube.rotation.y < -0.45 || cube.rotation.y > -1.05)) {
      if ((1 - mouse.x ) * 0.002 < 0 && cube.rotation.y < -0.45) {
        cube.rotation.y += spdx
      }
      if ((1 - mouse.x ) * 0.002 > 0 && cube.rotation.y > -1.05) {
        cube.rotation.y -= spdx
      }
    }

    /*if (mouse.y > 50 || mouse.y < -50) {

      if (mouse.y < -50 && cube.rotation.x > -0.35 ) {
        cube.rotation.x -= 0.002
      }
      if ( mouse.y > 50 && cube.rotation.x < -0.25) {
        cube.rotation.x += 0.002
      }
    }*/
  }
  evolveSmoke();
  renderer.render( scene, camera );
}

function evolveSmoke() {
  var sp = smokeParticles.length;
  while(sp--) {
    smokeParticles[sp].rotation.z += (delta * 0.2);
  }
}

function render() {
  renderer.render( scene, camera );
}

function onWindowResize() {
  windowHalf = new THREE.Vector2( document.getElementById('welcome').offsetWidth / 2, document.getElementById('welcome').offsetHeight / 2 );
  camera.aspect = document.getElementById('welcome').offsetWidth / document.getElementById('welcome').offsetHeight;
  renderer.setSize( document.getElementById('welcome').offsetWidth , document.getElementById('welcome').offsetHeight );
  camera.updateProjectionMatrix();
}

function onTransitionEnd( event ) {
  event.target.remove();
}
